import { createStore } from '@datorama/akita';
import { type History } from 'types/models';

export type HistoryState = History;

const store = createStore<HistoryState>({ storeName: undefined, storeId: undefined }, { name: 'history' });

export default store;
